import { Button, Center, Group, Modal, Text, Tooltip } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconTrash } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import React from 'react'
import { deleteBonus } from '../../../../../api/agencyAdmin/bonus';

import { successNotification } from '../../../../../utility/notification';
import classes from '../../typesOfMonths/TypeOfMonths.module.css';


function ActionCell({ row, queryKey }) {

    const [deleteDialogOpened, { open: openDeleteDialog, close: closeDeleteDialog }] = useDisclosure(false);


    const queryclient = useQueryClient()
    const { isDeletePending, mutate: mutateDelete } = useMutation({
        mutationFn: deleteBonus,
        onSuccess: async (res) => {
            await queryclient.invalidateQueries({
                queryKey
            })

            successNotification({
                message: res?.message
            });


            handleDeleteChange()
        }
    })



    const handleDeleteChange = () => {

        closeDeleteDialog();

    };


    return (
        <>
            <Group justify="center" p="md">
                {/* Switch for activating/inactivating user */}



                <div className={classes.icon_button_danger}>
                    <Tooltip label="Delete">
                        <IconTrash
                            style={{ color: 'white', fontSize: '20px', alignItems: 'center' }}
                            onClick={openDeleteDialog}
                        >

                        </IconTrash>
                    </Tooltip>
                </div>

                {/* Modal for deleting agency code */}
                <Modal opened={deleteDialogOpened} onClose={closeDeleteDialog} centered title="Delete Confirmation">
                    <Text>Are you sure you want delete this user bonus?</Text>
                    <Center mt="md">
                        <Button
                            variant="gradient"
                            gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
                            onClick={() => mutateDelete({ id: row?.id })}
                            loading={isDeletePending}
                        >
                            Confirm
                        </Button>
                    </Center>
                </Modal>


            </Group>
        </>
    )
}

export default ActionCell
